export default [
  { pattern: /^\/schools\/dashboard(.)*/, name: 'Dashboard' },
  { pattern: /^\/schools\/vacancies\/create(.)*/, name: 'New Vacancy' },
  { pattern: /^\/schools\/vacancies\/duplicate(.)*/, name: 'Duplicate Vacancy' },
  { pattern: /^\/schools\/vacancies(.)*/, name: 'Vacancies' },
  { pattern: /^\/schools\/\d+\/vacancies\/\d+\/applications\/\d+(.)*\/compare/, name: 'Vacancies' },
  { pattern: /^\/schools\/\d+\/vacancies\/\d+\/applications\/\d+(.)*/, name: 'Review Vacancy Applications' },
  { pattern: /^\/schools\/\d+\/candidates\/\d+\/partner*/, name: 'Review Vacancy Applications' },
  { pattern: /^\/schools(\/(?:(\d+)))?\/vacancies*/, name: 'Vacancy' },
  { pattern: /^\/schools\/admin(.)*/, name: 'Admin' },
  { pattern: /^\/schools\/reports(.)*/, name: 'Reports' },
  { pattern: /^\/schools\/?$/, name: 'Schools' },
  { pattern: /^\/schools(.)+/, name: 'School' },
  { pattern: /^\/candidate\/my-applications\/more-vacancies*/, name: 'More Vacancies to Apply' },
  { pattern: /^\/candidate\/my-applications\/(\d+)\/details*/, name: 'Application Details' },
  { pattern: /^\/candidate\/my-applications\/(\d+)\/draft*/, name: 'Apply For Vacancy' },
  { pattern: /^\/candidate\/my-applications(.)*/, name: 'My Applications' },
  { pattern: /^\/candidate\/my-references(.)*/, name: 'My References' },
  { pattern: /^\/candidate\/my-profile\/link-search-associates-account*/, name: 'Link Search Associates Account' },
  { pattern: /^\/candidate\/my-profile(.)*/, name: 'My Profile' },
  { pattern: /^\/candidate(.)*/, name: 'Candidate' },
  { pattern: /^\/user-account(.)*/, name: 'User Account' },
  { pattern: /^\/admin\/users\/administrators\/create(.)*/, name: 'New User Administrator' },
  { pattern: /^\/admin\/users(.)*/, name: 'Users' },  
  { pattern: /^\/admin\/schools(.)*/, name: 'Schools' },
  { pattern: /^\/admin\/reports(.)*/, name: 'Reports' },
  { pattern: /^\/admin\/audit(.)*/, name: 'Audit' }
];



// WEBPACK FOOTER //
// ./src/constants/route-title.js